module.exports = __webpack_public_path__ + "static/media/pic.c50cac7e.svg";